import { gql } from '@apollo/client'

export const M2_LEGAL_AREA_QUERY = gql`
  query m2LegalAreas(
    $sortBy: M2LegalAreaSort
    $filter: M2LegalAreaFilter
    $page: Int
    $limit: Int
  ) {
    m2LegalAreas(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        title
        archived
      }
      metadata {
        totalCount
      }
    }
  }
`
